export default __webpack_public_path__ + "static/media/bitski.08fb484a.svg";